module.exports = __webpack_public_path__ + "img/B6B8B1_994A24_315C81_927963-256px.c5ac4469.png";